(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('ControllerPayment',ControllerPayment);

    ControllerPayment.$inject = ['$resource','DateUtils'];

    function ControllerPayment($resource, DateUtils) {
        var resourceUrl = "api/controller-payment/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET', isArray:true},
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.paymentDate = DateUtils.convertDateTimeFromServer(data.paymentDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function(data) {
                    data.paymentDate = DateUtils.convertLocalDateToServer(data.paymentDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function(data) {
                    data.paymentDate = DateUtils.convertLocalDateToServer(data.paymentDate);
                    return angular.toJson(data);
                }
            }
        })
    }
})();
